import { PayloadAction, createSlice } from '@reduxjs/toolkit';
export const GIFT_RECORD_KEY = 'app::report::gift::record';
export type Gift = {
    HostID: number;
    GameType: number;
    GameCount: number;
    DealerName: string;
    ID: number;
    Balance: number;
    GiftAmount: number;
    GiftType: number;
    Shoes: number;
    Round: number;
    Date: string;
    Time: string;
};
export type GiftRecordTotalResult = {
    gifts: Array<Gift>;
    totalAmount: number;
};
export type GiftRecordState = {
    records: GiftRecordTotalResult;
    total: number;
    request: boolean;
};
const updateTotal = (
    state: GiftRecordState,
    actions: PayloadAction<number>
) => {
    state.total = actions.payload;
    state.records = { gifts: [], totalAmount: 0 };
    state.request = true;
};
const updateRecord = (
    state: GiftRecordState,
    actions: PayloadAction<{
        records: GiftRecordState['records'];
    }>
) => {
    state.records = actions.payload.records;
};
const reset = (state: GiftRecordState) => {
    state.records = initialGiftRecordState.records;
    state.total = initialGiftRecordState.total;
    state.request = false;
};
const initialGiftRecordState = {} as GiftRecordState;
const giftRecordSlice = createSlice({
    name: GIFT_RECORD_KEY,
    initialState: initialGiftRecordState,
    reducers: {
        updateTotal,
        updateRecord,
        reset,
    },
});
export const giftRecordSliceReducer = giftRecordSlice.reducer;
export const giftRecordSliceActions = giftRecordSlice.actions;
